import axios from "axios";
import config from "../config";
import { apiPath } from "../api-path";
import { ResultStatusModel } from "../models/result-status.model";
import { ref, uploadBytes, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase/firebase.config";
import { UploadResumeModel } from "../models/upload-resume.model";
import { ProfileResumeModel } from "../models/profile-resume.model";
import { SummaryResumeModel } from "../models/resume-summary.model";
import { CreateRoomModel } from "../models/create-room.model";
import { normalizeReportRecommend, ReportRecommendModel } from "../models/report-recommend.model";

export async function signIn(body): Promise<ResultStatusModel> {
    try {
        return axios.post(config.report_api.url + apiPath.sign_in, body, {
            headers: {
                'Content-Type': "application/json"
            }
        }).then(res => res.data as ResultStatusModel).catch(err => Promise.reject(err))
    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}
export async function getEmotional(image_url): Promise<ResultStatusModel> {
    try {
        return axios.post(config.report_api.url + apiPath.room.emotional_image, { image_url: image_url }, {
            headers: {
                'Content-Type': "application/json"
            }
        }).then(res => res.data as ResultStatusModel).catch(err => Promise.reject(err))
    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}
export async function verifyRoom(job_question_id, candidate_id, email): Promise<ResultStatusModel> {
    try {
        return axios.post(config.report_api.url + apiPath.room.verify, { job_question_id, candidate_id, email }, {
            headers: {
                'Content-Type': "application/json"
            }
        }).then(res => res.data as ResultStatusModel).catch(err => Promise.reject(err))
    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}


export async function saveQuestionPublic(questions, job_title, job_level): Promise<ResultStatusModel> {
    try {
        return axios.post(config.report_api.url + apiPath.room.save_questions_bank, { questions, job_title, job_level }, {
            headers: {
                'Content-Type': "application/json"
            }
        }).then(res => res.data as ResultStatusModel).catch(err => Promise.reject(err))
    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}
export async function uploadResume(fileUpload, filename, type): Promise<UploadResumeModel> {
    try {
        const formData = new FormData();
        formData.append("resume", fileUpload, filename);
        formData.append("type", type);
        return axios.post(config.resume.upload_url + "/resume/upload", formData, {
            headers: {
                "x-api-key": config.resume.upload_x_api_key
            }
        }).then(res => res.data as UploadResumeModel).catch(err => Promise.reject(err))

    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}

export async function getPreFillResume(resume_key): Promise<ProfileResumeModel> {
    try {
        const body = {
            resume_key: resume_key
        }
        return axios.post(config.resume.lambda_url + "/resume-interview" + "/resume/profile", body, {
            headers: {
                "x-api-key": config.resume.upload_x_api_key
            }
        }).then(res => res.data as ProfileResumeModel).catch(err => Promise.reject(err))

    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}


export async function getSummaryResume(resume_key): Promise<SummaryResumeModel> {
    try {
        const body = {
            resume_key: resume_key
        }
        return axios.post(config.resume.lambda_url + "/resume-interview" + "/resume/summary", body, {
            headers: {
                "x-api-key": config.resume.upload_x_api_key
            }
        }).then(res => res.data as SummaryResumeModel).catch(err => Promise.reject(err));
    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}

export async function createRoom(body): Promise<CreateRoomModel> {
    try {

        return axios.post(config.report_api.url + "/client/interview/scoutout", { input: body }, {
            headers: {
                "x-api-key": config.resume.upload_x_api_key
            }
        }).then(res => res.data as CreateRoomModel).catch(err => Promise.reject(err));
    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}
export async function createRoomGeneral(body): Promise<CreateRoomModel> {
    try {

        return axios.post(config.report_api.url + "/client/interview/scoutout/general", { input: body }, {
            headers: {
                "x-api-key": config.resume.upload_x_api_key
            }
        }).then(res => res.data as CreateRoomModel).catch(err => Promise.reject(err));
    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}
export async function getQuestionPublic(job_title, job_level): Promise<ResultStatusModel> {
    try {
        return axios.post(config.report_api.url + apiPath.room.check_questions_bank, { job_title, job_level }, {
            headers: {
                'Content-Type': "application/json"
            }
        }).then(res => res.data as ResultStatusModel).catch(err => Promise.reject(err))
    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}

export async function generateQuestion(job_title, job_exp): Promise<any> {
    const body = {
        job_title: job_title,
        job_exp: job_exp,
    }
    try {
        return axios.post(config.quiz.url + apiPath.quiz.hard_skill, { input: body, totalQuestion: 6, tone: "professional" }, {
            headers: {
                'Content-Type': "application/json"
            }
        }).then(res => res.data as any).catch(err => Promise.reject(err))
    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}
export async function verifyPublicCandidate(company_id, job_question_id, candidate_id): Promise<ResultStatusModel> {
    try {
        return axios.post(config.report_api.url + apiPath.room.publicCandidate, { company_id, job_question_id, candidate_id }, {
            headers: {
                'Content-Type': "application/json"
            }
        }).then(res => res.data as ResultStatusModel).catch(err => Promise.reject(err))
    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}

/** เปิดลิงก์เชิญจากอีเมล — บันทึก timestamp ใน Firestore (แสดงในแอดมิน); ไม่ throw */
export function trackInviteEmailLinkOpen(payload: {
    job_question_id: string;
    candidate_id: string;
    company_id?: string | null;
}): void {
    const { job_question_id, candidate_id, company_id } = payload;
    if (!job_question_id || !candidate_id) return;
    const body: Record<string, string> = { job_question_id, candidate_id };
    if (company_id) body.company_id = company_id;
    axios
        .post(config.report_api.url + apiPath.room.trackInviteEmailLink, body, {
            headers: { "Content-Type": "application/json" },
        })
        .catch(() => {});
}
export async function autoResponse(job_title, level, question, mainLanguage, candidateInfo): Promise<ResultStatusModel> {
    try {
        return axios.post(config.quiz.url + "/gen-interview-question/auto-response", { job_title: job_title, level: level, question: question, language: mainLanguage, candidate_info: candidateInfo }, {
            headers: {
                'Content-Type': "application/json"
            }
        }).then(res => res.data as ResultStatusModel).catch(err => Promise.reject(err))
    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}
export async function getStandardAssessment(room_id): Promise<ResultStatusModel> {
    try {
        return axios.get(config.report_api.url + apiPath.room.std_assessment + "/" + room_id, {
            headers: {
                'Content-Type': "application/json"
            }
        }).then(res => res.data as ResultStatusModel).catch(err => Promise.reject(err))
    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}
export async function postReport(job_question_id, candidate_id, body): Promise<ResultStatusModel> {
    try {
        return axios.post(config.report_api.url + apiPath.room.report + "/" + job_question_id + "/" + candidate_id, { body: body }, {
            headers: {
                'Content-Type': "application/json"
            }
        }).then(res => res.data as ResultStatusModel).catch(err => Promise.reject(err))
    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}

export async function publicRoomDetail(job_question_id, company_id): Promise<ResultStatusModel> {
    try {
        return axios.post(config.report_api.url + "/public/room", { job_question_id, company_id }, {
            headers: {
                'Content-Type': "application/json"
            }
        }).then(res => res.data as ResultStatusModel).catch(err => Promise.reject(err))
    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}
export async function publicPostAddCandidate(job_question_id, company_id, input): Promise<ResultStatusModel> {
    try {
        return axios.post(config.report_api.url + "/client/interview", { job_question_id, company_id, input }, {
            headers: {
                'Content-Type': "application/json"
            }
        }).then(res => res.data as ResultStatusModel).catch(err => Promise.reject(err))
    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}

export async function postEmailToAdmin(body): Promise<ResultStatusModel> {
    try {
        return axios.post(config.report_api.url + apiPath.room.email_admin, body, {
            headers: {
                'Content-Type': "application/json"
            }
        }).then(res => res.data as ResultStatusModel).catch(err => Promise.reject(err))
    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}

export async function postEmailToAdminHR9(body: { candidate_id: string }): Promise<ResultStatusModel> {
    try {
        return axios.post(config.report_api.url + "/email/interview/complete_interview/hr9", body, {
            headers: {
                'Content-Type': "application/json"
            }
        }).then(res => res.data as ResultStatusModel).catch(err => Promise.reject(err))
    } catch (error: any) {
        throw new Error(`Failed to send email for HR9: ${error.message}`);
    }
}
export async function saveLog(input): Promise<ResultStatusModel> {
    try {
        return axios.post(config.report_api.url + "/public/drop-cv", {input}, {
            headers: {
                'Content-Type': "application/json"
            }
        }).then(res => res.data as ResultStatusModel).catch(err => Promise.reject(err))
    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}

export async function SendEmailDropCV(companyName): Promise<any> {
    try {
       
        return axios.post(config.report_api.url + "/email/drop-cv/complete", {companyName}, {
            
        }).then(res => res.data as any).catch(err => Promise.reject(err));
    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}
export async function getRoom(room_id, email): Promise<ResultStatusModel> {
    try {
        return axios.get(config.report_api.url + apiPath.room.detail + "/" + room_id + "?email=" + encodeURIComponent(email), {
            headers: {
                'Content-Type': "application/json"
            }
        }).then(res => res.data as ResultStatusModel).catch(err => Promise.reject(err))
    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}

export async function getHardSkill(template_id): Promise<ResultStatusModel> {
    try {
        return axios.post(config.report_api.url + "/public/get-hard-skill", { template_id }, {
            headers: {
                'Content-Type': "application/json"
            }
        }).then(res => res.data as ResultStatusModel).catch(err => Promise.reject(err))
    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}

export async function getReportSystem(report_id): Promise<ReportRecommendModel> {
    try {
        return axios
            .get(config.report_api.recommend_url + "report/" + report_id, {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((res) => normalizeReportRecommend(res.data))
            .catch((err) => Promise.reject(err));
    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}
export async function updateReport(body, report_id): Promise<ResultStatusModel> {
    try {
        return axios.patch(config.report_api.url + apiPath.room.detail + "/" + report_id, body, {
            headers: {
                'Content-Type': "application/json"
            }
        }).then(res => res.data as ResultStatusModel).catch(err => Promise.reject(err))
    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}
export async function updateReportByQuestionID(job_question_id, candidate_id, report_id, question_id, body): Promise<ResultStatusModel> {
    try {
        const questionData = {
            questionData: body
        }
        return axios.put(config.report_api.url + apiPath.room.report + "/" + job_question_id + "/" + candidate_id + "/" + report_id + "/" + question_id,

            questionData, {
            headers: {
                'Content-Type': "application/json"
            }
        }).then(res => res.data as ResultStatusModel).catch(err => Promise.reject(err))
    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}

export async function updateReportByLastQuestion(job_question_id, candidate_id, report_id, question_id, body, countTime, app_id): Promise<ResultStatusModel> {
    try {
        const questionData = {
            questionData: body,
            total_duration: countTime,
            app_id: app_id
        }
        return axios.put(config.report_api.url + apiPath.room.report + "/last/" + job_question_id + "/" + candidate_id + "/" + report_id + "/" + question_id,

            questionData, {
            headers: {
                'Content-Type': "application/json"
            }
        }).then(res => res.data as ResultStatusModel).catch(err => Promise.reject(err))
    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}


export async function updateReportWithAudio(body, audioBlob, report_id): Promise<ResultStatusModel> {
    const formData = new FormData();
    formData.append("audio", audioBlob, "audio.mp3"); // Append the Blob file
    formData.append("conversation_logs", body); // Add other fields if needed
    try {
        return axios.patch(config.report_api.url + apiPath.report_audio + "/" + report_id, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }).then(res => res.data as ResultStatusModel).catch(err => Promise.reject(err))
    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}
export async function uploadSnapShotToFirebase(file: Blob, snapshot_id: string): Promise<string> {
    try {
        if (!file) {
            console.error("❌ No file provided!");
            return Promise.reject("File is missing.");
        }

        // 🔹 Determine file type (MIME)
        const fileType = file.type; // Example: "image/png", "image/jpeg"
        let fileExtension = "";

        // 🔹 Map MIME type to extension
        if (fileType === "image/png") {
            fileExtension = "png";
        } else if (fileType === "image/jpeg") {
            fileExtension = "jpg";
        } else if (fileType === "image/webp") {
            fileExtension = "webp";
        } else {
            console.warn("⚠️ Unsupported file type, defaulting to PNG.");
            fileExtension = "png"; // Default fallback
        }

        // 🔹 Define storage path with correct extension
        const fileName = `snapshot_reports/${snapshot_id}_snapshot.${fileExtension}`;
        const storageRef = ref(storage, fileName);

        // 🔹 Upload file to Firebase Storage
        const snapshot = await uploadBytes(storageRef, file, { contentType: fileType });

        // 🔹 Get public download URL
        const imageUrl = await getDownloadURL(snapshot.ref);
        console.log("✅ Snapshot uploaded successfully:", imageUrl);

        return imageUrl;
    } catch (error: any) {
        console.error("❌ Error uploading snapshot:", error);
        throw new Error(`Failed to upload snapshot: ${error.message}`);
    }
}
export async function uploadAudioToFirebase(
    file,
    question_id,
    candidate_id,
    fileType,
    onProgress?: (percent: number) => void
): Promise<String> {
    try {
        if (!file || (file.size !== undefined && file.size < 1)) {
            console.error("No file or empty file!");
            return Promise.reject(new Error("No file or empty file"));
        }

        const fileExtension = fileType.includes("webm") ? "webm" : "wav";

        const storageRef = ref(storage, `audio_reports/${question_id}_${candidate_id}.${fileExtension}`);

        const uploadTask = uploadBytesResumable(storageRef, file);

        return new Promise((resolve, reject) => {
            uploadTask.on(
                "state_changed",
                (snapshot) => {
                    if (onProgress && snapshot.totalBytes > 0) {
                        const percent = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        onProgress(percent);
                    }
                },
                (error: any) => {
                    reject(new Error(`Failed to upload audio: ${error?.message || error}`));
                },
                async () => {
                    try {
                        const audioUrl = await getDownloadURL(uploadTask.snapshot.ref);
                        resolve(audioUrl);
                    } catch (err: any) {
                        reject(new Error(`Failed to get download URL: ${err?.message || err}`));
                    }
                }
            );
        });
    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}

export async function uploadVideoToFirebase(file, reportId): Promise<String> {
    try {
        if (!file) {
            console.error("No file selected!");
            return Promise.reject("err");
        }

        // 🔹 Define storage path
        const storageRef = ref(storage, `video_reports/${reportId}_video`);

        // 🔹 Upload file to Firebase Storage
        const snapshot = await uploadBytes(storageRef, file);

        // 🔹 Get download URL
        const audioUrl = await getDownloadURL(snapshot.ref);

        // 🔹 Send URL to backend to update Firestore
        return audioUrl;
    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
};
export async function getReport(report_id): Promise<ResultStatusModel> {
    try {
        return axios.get(config.report_api.url + apiPath.room.detail + "/" + report_id, {
            headers: {
                'Content-Type': "application/json"
            }
        }).then(res => res.data as ResultStatusModel).catch(err => Promise.reject(err))
    } catch (error: any) {
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}

export async function getByPassChooseLanguage(job_question_id): Promise<any> {
    try {
        // First, get the company_id from the interview question
        const interviewRes = await axios.get(config.report_api.url + "/template/question/" + job_question_id, {
            headers: {
                'Content-Type': "application/json"
            }
        }).then(res => res.data).catch(() => null);
        
        if (!interviewRes || !interviewRes.data || !interviewRes.data.company_id) {
            return { is_success: false, data: { en: [], th: [] } };
        }
        
        const company_id = interviewRes.data.company_id;
        
        // Then get the by-pass-choose-language settings from PUBLIC API (no authentication required)
        return axios.get(config.report_api.url + "/settings/public/by-pass-choose-language/" + company_id, {
            headers: {
                'Content-Type': "application/json"
            }
        }).then(res => res.data).catch(err => {
            console.error("Error fetching by-pass-choose-language:", err);
            return { is_success: false, data: { en: [], th: [] } };
        });
    } catch (error: any) {
        console.error("Error in getByPassChooseLanguage:", error);
        return { is_success: false, data: { en: [], th: [] } };
    }
}